
import { useWindowSize } from "../../hooks";
import DesktopNavBar from "./Desktop";
import MobileNavBar from "./Mobile";


export default function NavBar() {
  const { width } = useWindowSize();

  const gradientStyle = {
    background:
      "linear-gradient(90deg, rgba(20, 20, 20, 0.40) 0%, rgba(203, 203, 203, 0.40) 100%)",
  };

  return (
    <header>
      <nav aria-label="Global" style={gradientStyle}>
        {width > 639 ? <DesktopNavBar /> : <MobileNavBar />}
      </nav>
    </header>
  );
}